import { useMemo, useRef } from "react";
import type { ProcurementScope } from "../shared/useProcurementScope";

export function useRfqReadScope(scope: ProcurementScope, rfqId: string | undefined) {
  const current = useRef({ scope, rfqId });
  if (current.current.scope !== scope || current.current.rfqId !== rfqId) {
    current.current = { scope, rfqId };
  }
  const context = current.current;
  return useMemo(() => ({
    isCurrent: () => scope.isCurrent() && current.current === context,
  }), [context, scope]);
}
